import { Maybe } from '@acme/core'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type State = {
    progresso: Maybe<number>
    gerandoPdf: boolean
    baixandoPdf: boolean
    ultimoProcesso: Maybe<number>
}

type Dispatch =
    | {
          action: 'PROGRESSO'
          data: Maybe<number>
      }
    | {
          action: 'GERANDO_PDF'
          data: boolean
      }
    | {
          action: 'ULTIMO_PROCESSO'
          data: Maybe<number>
      }
    | {
          action: 'BAIXANDO_PDF'
          data: boolean
      }

type Store = {
    state: State
    dispatch: (action: Dispatch, ...actions: Dispatch[]) => void
}

export const useCalculoStore = create<Store>()(
    persist(
        set => ({
            state: {
                progresso: null,
                gerandoPdf: false,
                baixandoPdf: false,
                ultimoProcesso: null,
            },
            dispatch: (...actions) => {
                for (const { action, data } of actions) {
                    switch (action) {
                        case 'PROGRESSO':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    progresso: data,
                                },
                            }))
                            break
                        case 'GERANDO_PDF':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    gerandoPdf: data,
                                },
                            }))
                            break
                        case 'ULTIMO_PROCESSO':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    ultimoProcesso: data,
                                },
                            }))
                            break
                        case 'BAIXANDO_PDF':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    baixandoPdf: data,
                                },
                            }))
                            break
                    }
                }
            },
        }),
        {
            name: 'calculo-ponto-store',
            partialize: state => ({
                ultimoProcesso: state.state.ultimoProcesso,
            }),
            version: 1,
        },
    ),
)
